<template>
  <div class="row py-4 group-list-item">
    <div class="col-sm-5 pl-0 mb-sm-1">
      <img v-bind:src="group.image" v-bind:alt="group.leaders" class="group-leader-image" />
    </div>
    <div class="col-sm d-flex flex-column">
      <h4>
        Leader(s): {{ group.leader }} 
        <small class="text-muted">ID: {{ group.id }}</small>
      </h4>
      <p class="group-leader-info flex-grow-1">
        Coordinator(s): {{ group.coordinator}} <br />
        Location: {{ group.location }} <br />
        Time: {{ group.day }} @ {{ group.time }} <br />
        Type: {{ group.type }} <br />
        {{ signupsLeft }} of 18 Spots left
      </p>
      <div>
        <b-button variant="dark" class="px-4 mr-3" v-b-modal="'modal-group-' + group.id" :disabled="signupsLeft == 0">Sign-up</b-button>
        <b-button variant="outline-dark" class="px-4" @click="getDirections(group)">Get Directions</b-button>
      </div>
    </div>

    <b-modal
      ref="modal"
      v-bind:id="'modal-group-' + group.id "
      centered
      v-bind:title="'Sign-up for ' + group.leader + ' group'"
      @ok="onSubmit"
      @shown="resetForm"
    >
      <b-form-input
        v-model="form.name"
        placeholder="Enter your name"
        class="mb-3"
      ></b-form-input>
      <b-form-input
        v-model="form.email"
        type="email"
        placeholder="Enter your email"
        class="mb-3"
      ></b-form-input>
      <b-form-input
        v-model="form.phone"
        type="tel"
        placeholder="Enter your phone number"
      ></b-form-input>
      <input type="hidden" id="groupID" name="groupID" :value="group.id">
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import groups from '@/groups.js'

export default {
  name: 'GroupListItem',
  props: {
    group: Object
  },
  asyncComputed: {
    signupsLeft: {
      async get() {
        var retValue = 18
        await groups.getGroup(this.group.id).then((response) => {
          console.log(response)
          retValue -= response.signups
        })
        return retValue
      },
      default () {
        return (this.group.signups != null) ? 18 - this.group.signups : 18
      },
      watch: ['signupsCompleted']
    }
  },
  data: function() {
    return {
      form: {
        name: '',
        email: '',
        phone: ''
      },
      signupsCompleted: 0
    }
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault()
      this.$root.$emit('show-spinner')
      let formUrl = 'http://grbaptist.org/gravityformsapi/forms/6/submissions'
      let self = this
      axios.post(formUrl, {
        "input_values": {
          "input_1": this.form.name,
          "input_6": this.form.email,
          "input_5": this.form.phone,
          "input_4": evt.modalId.split('-').pop()
        }
      })
      .then((response) => {
        this.$root.$emit('hide-spinner')
        this.$toasted.success('Thank you for signing up', {
          position: 'top-center',
          duration: 1500,
          fullWidth: true
        })
        groups.updateSignups(this.group.id)
          .then((response) => {
            self.signupsCompleted += 1
          })
          .catch((err) => {
            // fail silently
          })
      })
      .catch((error) => {
        this.$root.$emit('hide-spinner')
        this.$toasted.error('An error occurred during the sign up.', {
          position: 'top-center',
          duration: 1500,
          fullWidth: true
        })
      })

      this.hideModal()
    },
    onCancel(evt) {
      evt.preventDefault()
      this.hideModal()
    },
    resetForm() {
      this.form.name = ''
      this.form.email = ''
      this.form.phone = ''
    },
    hideModal() {
      this.$nextTick(() => {
        // Wrapped in $nextTick to ensure DOM is rendered before closing
        this.$refs.modal.hide()
      })
    },
    getDirections(currentGroup) {
      let baseUrl = 'https://www.google.com/maps/dir/?api=1'
      let address = currentGroup.address.lat + ',' +
                    currentGroup.address.lng + ' '
      let directionUrl = baseUrl + '&destination=' + address.split(' ').join('+')
      window.open(directionUrl, '_blank')
    }

  }
}
</script>

<style>
.group-list-item {
  border-bottom: 1px solid #222;
}
.group-leader-image {
  width: 100%;
  max-height: 300px;
  object-fit: cover;
}
.group-leader-info {
  line-height: 2rem;
}
</style>
